import uuid from "react-uuid";
import {initialVaultState} from "./initialVaultState";

export const validSizes = ["100x100", "150x100", "200x100"];

const getBlockOuts = (width) => {
    switch (width) {
        case 100:
            return [
                {
                    id: uuid(),
                    colloquialism: 'Sagex-',
                    name: 'Einlage',
                    type: 'sagex',
                    width: 60,
                    height: 50,
                    x: 20,
                    y: 0
                }
            ];
        case 150:
            return [
                {
                    id: uuid(),
                    colloquialism: 'Sagex-',
                    name: 'Einlage',
                    type: 'sagex',
                    width: 60,
                    height: 50,
                    x: 45,
                    y: 0
                }
            ];
        case 200:
            return [
                {
                    id: uuid(),
                    colloquialism: 'Sagex-',
                    name: 'Einlage',
                    type: 'sagex',
                    width: 60,
                    height: 50,
                    x: 25,
                    y: 0
                },
                {
                    id: uuid(),
                    colloquialism: 'Sagex-',
                    name: 'Einlage',
                    type: 'sagex',
                    width: 60,
                    height: 50,
                    x: 115,
                    y: 0
                }
            ];
        default:
            return [];
    }
}

const getWall = (width) => {
    return {sleeves: [], blockOuts: getBlockOuts(width), drainages: [], groundings: [], cRails: []}
}

const getWalls = (size) => {
    const width = parseInt(size.split('x')[0]);

    return [getWall(width), getWall(width), getWall(100), getWall(100)]
}

export const create = dimension => {
    return {
        ...initialVaultState,
        isStockVault: true,
        selectedSize: dimension,
        walls: getWalls(dimension)
    };
}
